import { Destination } from '@addins/external-itinerary/schema/destination';
import { Injectable } from '@angular/core';
import { ActionSheetButton, ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProviderName } from '../../schema/provider-name';
import { ExternalItineraryProviderService } from '../external-itinerary-provider/external-itinerary-provider.service';

@Injectable()
export class StartItineraryService {
  constructor(
    private externalItineraryProvider: ExternalItineraryProviderService,
    private actionSheet: ActionSheetController,
    private translate: TranslateService
  ) {}

  navigateTo(destination: Destination): void {
    const savedProvider: string = this.externalItineraryProvider.currentItineraryProvider.current;
    const providers = this.externalItineraryProvider.providers;

    if (providers.indexOf(savedProvider) >= 0) {
      this.navigateToWithProvider(destination, savedProvider);
    } else if (providers.length === 1) {
      this.navigateToWithProvider(destination, providers[0]);
    } else if (providers.length > 1) {
      this.selectProvider(providers).then(result =>
        result.role !== 'cancel' ? this.navigateToWithProvider(destination, result.role) : null
      );
    }
  }

  private navigateToWithProvider(destination: Destination, providerName: string) {
    this.externalItineraryProvider.get(ProviderName[providerName]).navigateTo(destination);
  }

  private selectProvider(providers: string[]) {
    const buttons = providers.map(this.createButton);

    return this.actionSheet
      .create({
        header: this.translate.instant('Mobile.SelectExtItineraryProvider'),
        backdropDismiss: false,
        buttons: [...buttons, { text: this.translate.instant('Mobile.Cancel'), role: 'cancel', icon: 'close' }]
      })
      .then(actionSheetElement => actionSheetElement.present().then(() => actionSheetElement.onWillDismiss()));
  }

  private createButton(provider: string): ActionSheetButton<any> {
    return {
      text: provider,
      role: provider,
      icon: 'navigate-circle',
      cssClass: 'ion-text-capitalize'
    };
  }
}
